export default __webpack_public_path__ + "static/media/doc_experience.f3ad35d2.webp";